export enum MediaControlType {
  Play = 'play',
  PlayMask = 'play-mask',
  Seek = 'seek',
  Volume = 'volume',
  TimePoints = 'time-points',
  Fullscreen = 'fullscreen',
  PlaybackRate = 'playback-rate',
  Mute = 'mute',
  Subtitles = 'subtitles',
  Captions = 'captions',
}
